<template>
  <Card class="pt-1 pb-1 pl-1 pr-3">
    <v-layout row justify-space-between align-center>
      <v-flex shrink>
        <Select :items="dashboardList" @change="goto" :label="$t('Dashboard')" itemText="name" itemValue="path"
          :selection="currentRoute" class="dashboard"></Select>
      </v-flex>
      <div v-if="plantSelectionRequired">
        <v-autocomplete class="mx-3 autocomplete" :background-color="$vuetify.theme.bg" :items="plantNameList"
          v-model="plantName" @change="plantChangeHandler" placeholder="Search Plant" solo-inverted flat dense hide-no-data hide-details
          hide-selected :allow-overflow="false" :single-line="true" outline>
          <template v-slot:item="{ item }">
            <div class="unq-autocomplete-item">
              {{ item }}
            </div>
          </template>
        </v-autocomplete>
      </div>
      <div class="d-flex align-center justify-center">
        {{ time }} <v-icon class="ml-2">language</v-icon>
      </div>
    </v-layout>
  </Card>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import { timezoneMixin } from '@/util/mixin/index.js'

export default {
  mixins: [timezoneMixin],
  data() {
    return {
      interval: null,
      plantName: null,
    }
  },
  mounted() {
    this.updateTime()
    this.interval = setInterval(this.updateTime, 60 * 1000)
    this.plantName = this.getActivePlantInfo("plant_name")
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  },
  computed: {
    ...mapGetters([
      "getPlantId",
      'getDashboardList',
      'getSelectedPlantId',
      "getPlantList",
      "getActivePlantInfo",
      "getGeneralState",
    ]),
    plantNameList() {
      return this.getPlantList.map((el) => el.name);
    },
    plantIdList() {
      return this.getPlantList.map((el) => el.id);
    },
    currentRoute() {
      return this.$route.path
    },
    dashboardList() {
      const list = _.cloneDeep(this.getDashboardList)
      return list
    },
    plantSelectionRequired() {
      return (
        this.$route.name !== "home" &&
        this.$route.name !== "thinkHome" &&
        this.$route.name !== "plantAnalytics"
      );
    },
  },
  methods: {
    ...mapActions(["fetchNotification", "fetchActivePlantDetails"]),
    ...mapMutations([
      "SET_THEME",
      "SET_MAP_REDIRECT_PLANT",
      "SET_AUTO_RELOAD",
      "SET_INSTANT_REFRESH",
      "SET_MINI_NAV",
    ]),
    goto(path) {
      this.$router.push(path)
    },
    async plantChangeHandler() {
      if (this.plantSelectionRequired) {
        const plantId = this.getPlantId(this.plantName)[0];
        if (!plantId) {
          return;
        }

        await this.fetchActivePlantDetails(plantId)
        if (this.getGeneralState("mapRedirectPlant")) {
          this.SET_MAP_REDIRECT_PLANT(false);
        }
      }
    }
  },
  watch: {
    getSelectedPlantId() {
      this.updateTime()
      this.plantName = this.getActivePlantInfo("plant_name")
    }
  }
}
</script>

<style scoped>
.autocomplete {
  display: none;
}

@media (max-width:510px) {
  .dashboard {
    display: none;
  }
  .autocomplete {
    margin-left: 0px !important;
    margin-right: 50px !important;
    font-size: 12px;
    display: block;
    padding: 10px 0px;
  }
}
</style>

<style>
.autocomplete .v-input__control .v-input__slot .v-select__slot input {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

.unq-autocomplete-item {
  height: 27px;
  color: var(--v-primary-text);
  font-size: 12px !important;
}


.v-list--dense .v-list__tile:not(.v-list__tile--avatar):has(.unq-autocomplete-item) {
  height: 32px;
}
</style>